import { useEffect } from "react";
import { useMotionValue } from "framer-motion";

// Measure on layout changes, never on every animation frame. Coordinates remain local.
export const useLaunchGeometry = (rootRef) => {
  const geometry = useMotionValue(null);
  useEffect(() => {
    // Child layout effects precede the parent host ref attachment. Connect after commit.
    let frame, resize, attempts = 0;
    const connect = () => {
      const root = rootRef.current;
      const track = root?.querySelector('[data-testid="energy-core-track"]');
      const moon = root?.querySelector('[data-testid="launch-moon-orb"]');
      const beyond = root?.querySelector('[data-testid="launch-beyond-point"]');
      if (!root || !track || !moon || !beyond) {
        if (++attempts < 10) frame = requestAnimationFrame(connect);
        return;
      }
      const measure = () => {
        const r = root.getBoundingClientRect(), t = track.getBoundingClientRect();
        const m = moon.getBoundingClientRect(), b = beyond.getBoundingClientRect();
        geometry.set({
          start: t.left - r.left + 1, length: Math.max(0, t.width - 2), y: t.top - r.top + t.height / 2,
          moonX: m.left - r.left + m.width / 2, moonY: m.top - r.top + m.height * 0.2,
          beyondX: b.left - r.left + b.width / 2, beyondY: b.top - r.top + b.height / 2,
        });
      };
      resize = new ResizeObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); });
      [root, track, moon, beyond].forEach((element) => resize.observe(element));
      measure();
    };
    frame = requestAnimationFrame(connect);
    return () => { resize?.disconnect(); cancelAnimationFrame(frame); };
  }, [rootRef, geometry]);
  return geometry;
};